import { createSelector } from 'reselect'
import Fuse from 'fuse.js'
import { SUCCESS } from 'utils/statusConstants'

export default createSelector(
  (state, { endpoint }) => state.sort[endpoint],
  (state) => state.search,
  (state, { loadStatus }) => loadStatus(state),
  (state, { endpoint, listState }) =>
    listState(state) || state.data[endpoint] || {},
  (_, { keys }) => keys,
  (sort, listSearch, loadStatus, entitiesByID, keys) => {
    if (loadStatus === SUCCESS) {
      const sortFn = (searchedList) => {
        if (!sort) return []

        const sortBy = sort.sortBy

        return searchedList.sort((a, b) => {
          if (a[sortBy] < b[sortBy] || !b[sortBy])
            return sort.order === 'desc' ? 1 : -1
          if (a[sortBy] > b[sortBy] || !a[sortBy])
            return sort.order === 'desc' ? -1 : 1
          return 0
        })
      }

      if (listSearch && listSearch.length) {
        const fuse = new Fuse(Object.values(entitiesByID), {
          shouldSort: false,
          threshold: 0.4,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: [
            ...(keys.areFunctions ? Object.keys(keys.sortable) : keys.sortable),
            ...keys.nonSortable,
          ],
        })

        return sortFn(
          fuse.search(listSearch).map((entity) => entitiesByID[entity.id]),
        )
      }

      return sortFn(Object.values(entitiesByID))
    }

    return []
  },
)
